import {TemplateType} from "@generated"
import {StateLabel} from "@platform/models/state-labels/state-label"

export const SceneTypeLabels: Map<TemplateType, StateLabel<TemplateType>> = new Map<TemplateType, StateLabel<TemplateType>>([
    [TemplateType.Scene, {state: TemplateType.Scene, label: "Scene", background: "#ffab4a"}],
])
